/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/base/header/index.less';

import router from 'assets/js/common/router/index';
import browser from 'assets/js/modules/browser';
import ScrollToFixed from 'assets/js/modules/scrollToFixed';
import 'APP_THEME/_common/vip_level_popup/vip_level_popup';
import VipLevelTooltip from 'APP_THEME/_common/vip_level_tooltip/vip_level_tooltip';
import Menu from 'APP_THEME/_common/base/header/menu';
import MenuMobile from 'APP_THEME/_common/base/header/menu.mobile';

export default class {
    static init() {
        this.updateData();
        var $header = $('#header');
        var loginPopup;
        const menu = new Menu($header);
        menu.init();
        const menuMobile = new MenuMobile();
        menuMobile.init();

        new ScrollToFixed({
            headers: $('.mobile-header-toolbar')
        });

        $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
            options.crossDomain = {
                crossDomain: true
            };
            options.xhrFields = {
                withCredentials: true
            };
        });

        const vipLevelTooltip = new VipLevelTooltip();
        vipLevelTooltip.open();
    }

    static updateData() {
        let $loginDiv = $('.account-and-cart .account');

        $.getJSON(router.generate('/_cached_page_data', browser.getUrlVars()))
            .done(function(data) {
                var $mobileLoginBlock = $('.mobile-menu .account');
                var $cartItemsCountBlock = $('.js-cart-items-count');
                var $vipLevelBar = $('.vip-level-bar');
                var $mobileMenu = $('.mobile-menu');

                $loginDiv.html(data.login);
                $mobileLoginBlock.html(data.login);

                if (data.vipLevel) {
                    $vipLevelBar.addClass('level-' + data.vipLevel).removeClass('hidden');
                }
                if (data.cartItemsCount > 0) {
                    $cartItemsCountBlock.text(data.cartItemsCount).show();
                }

                if (data.isLoggedIn) {
                    ONP.user.loggedIn = true;
                    $mobileMenu.addClass('logged-in');
                } else {
                    ONP.user.loggedIn = false;
                    $mobileMenu.removeClass('logged-in');
                }
            })
            .always(function() {
                $loginDiv.removeClass('hidden');

                if (ONP.defaultPath) {
                    $('.alt-locale-link').each(function() {
                        $(this).attr('href', router.generate(ONP.defaultPath, browser.getUrlVars(), $(this).data('locale')));
                    });
                }
            });
    }
}
